var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"loader-overlay"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":100,"width":10}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }